import { ApplicationRef, provideZoneChangeDetection } from '@angular/core';
import { enableDebugTools } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

/**
 * Replaced with a literal at build time via the `define` option in angular.json:
 * `true` by default, `false` for the production configuration. It must be a bare
 * identifier rather than an `environment` property, because esbuild only folds
 * literals and cannot prove a property read on the environment object is constant.
 */
declare const NG_TEST_HOOKS: boolean;

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .then(module => {
    const appReference = module.injector.get(ApplicationRef);
    const appComponent = appReference.components[0];
    enableDebugTools(appComponent);

    // Dynamically imported inside the guard so the whole module drops out of
    // builds where the flag is a literal false, rather than shipping dead code.
    if (NG_TEST_HOOKS) {
      return import('./app/_shared/testing/test-hooks').then(({ registerTestHooks }) =>
        registerTestHooks(module.injector)
      );
    }

    return;
  })
  .catch(error => console.error(error));
